import { render, staticRenderFns } from "./AiStandardCourse.vue?vue&type=template&id=41eddc53&scoped=true"
import script from "./AiStandardCourse.vue?vue&type=script&lang=js"
export * from "./AiStandardCourse.vue?vue&type=script&lang=js"
import style0 from "./AiStandardCourse.vue?vue&type=style&index=0&id=41eddc53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41eddc53",
  null
  
)

export default component.exports